import React from 'react'
import Loading from "../components/common/Loading";
import switchStyles from "../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import DistributorPOS from '@/components/DistributorPOS';

 

const distributorPOS = (Moba) => {
  return (
    <>
      <Head>
        <title>Wholesale Distribution POS System for Efficient Sales & Inventory</title>
        <link rel="canonical" href="https://queuebuster.co/distributor-pos" />
        <link rel="alternate" href="https://queuebuster.co/distributor-pos" hrefLang="en" />
        <meta name="description" content="QueueBuster's Wholesale POS System enhances productivity and provides real-time data access. Improve inventory tracking, order processing, and customer satisfaction with ease." />
        <meta property="og:title" content="Wholesale Distribution POS System for Boosted Productivity by QueueBuster POS" />
        <meta property="og:description" content="QueueBuster’s Wholesale POS System streamlines sales, order processing, and inventory management with real-time data access. Improve efficiency and enhance customer satisfaction." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/payment-og%2B(1)+(1).jpg" />
        <meta property="og:url" content="https://queuebuster.co/distributor-pos" />
      </Head>


      <DistributorPOS />
    </>
  )
}

export default distributorPOS